import React from "react";
import "./Spinner.css";

const Spinner = () => {
  return (
    <div className="flex flex-col items-center justify-center absolute z-50 inset-1/2">
      <div className="lds-roller">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

export default Spinner;
